/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
    'pando-agents': {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        data: '<svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M9.44336 2.88086L8.94336 2.88086C4.22917 2.88105 0.499999 6.23963 0.499999 11.1621C0.50006 15.8551 4.49754 19.4912 9.21973 19.4912L9.23047 19.4912L9.24121 19.4922C10.4694 19.5442 11.6953 19.3388 12.8408 18.8896C13.9862 18.4405 15.0269 17.7575 15.8965 16.8828C16.7661 16.0081 17.4457 14.9606 17.8926 13.8076C18.3394 12.6545 18.5439 11.4203 18.4922 10.1836L18.4912 10.1728L18.4912 10.1621C18.491 5.5267 14.6887 1.47392 9.44336 0.581054L9.44336 2.88086Z" stroke="#234357"/>' +
            '<rect x="4.89395" y="8.7373" width="2.30303" height="2.28571" fill="#0076DD"/>' +
            '<rect x="11.803" y="8.7373" width="2.30303" height="2.28571" fill="#0076DD"/>' +
            '</svg>'
    }
})
